export default {
  set (name, content){
    if(!name){
      return
    } 
    if(typeof content !== 'string'){
      content = JSON.stringify(content)
    }
    window.sessionStorage.setItem(name, content)
  },
  get (name){
    if(!name){
      return
    } 
    return window.sessionStorage.getItem(name)
  },
  remove (name){
    if(!name){
      return
    }
    window.sessionStorage.removeItem(name)
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js